import './problema.scss'

const problema = ({ problema, nls }) => {
  if (!problema) return null

  const catoutop = problema.catoutop

  const obterNomePrincipal = () => {
    if (catoutop === 'cat') {
      if (!problema.categoria) return null

      if (typeof problema.categoria === 'string') {
        return problema.categoria
      }

      if (typeof problema.categoria === 'object') {
        return problema.categoria?.nome || null
      }

      return null
    }

    if (catoutop === 'top') {
      return problema?.topico?.nome || nls.noName
    }

    return null
  }


  const formatarValorSemPercentual = valor => {
  if (valor === null || valor === undefined || valor === '') return null
  return String(valor).trim().replace(/%$/, '')
}

  const adicionarPercentual = valor => {
    if (valor === null || valor === undefined || valor === '') return null

    const texto = String(valor).trim()
    if (texto.endsWith('%')) return texto
    return `${texto}%`
  }

  const nomePrincipal = obterNomePrincipal()
  const indicadores = Array.isArray(problema.indicadores) ? problema.indicadores : []

  return (
    <div
  className='problema'
  data-cy='pdca-plan-detail-problem'
>
      <div className='problema__title'>
        {nls.problemFoundTitle.toUpperCase()}
      </div>

      <div className='problema__content'>
        {nomePrincipal && (
          <div
  className='problema__main'
  data-cy='pdca-plan-detail-problem-main'
>
            <span className='problema__label'>
              {catoutop === 'cat' ? nls.categoryLabel : nls.topicLabel}
            </span>
            <strong className='problema__value'>
              {nomePrincipal}
            </strong>
          </div>
        )}

        {indicadores.length > 0 && (
          <div
  className='problema__indicators'
  data-cy='pdca-plan-detail-indicators'
>
            <div className='problema__indicators-title'>
              {nls.indicatorsTitle}
            </div>

            <div className='problema__indicators-list'>
              {indicadores.map((indicador, index) => (
                <div
  key={`problema-indicador-${index}`}
  className='problema__indicator-card'
  data-cy='pdca-plan-detail-indicator'
>
                  <div className='problema__indicator-layout'>
                    <div className='problema__indicator-name'>
                      {indicador?.nome || ''}
                    </div>

                    <div className='problema__indicator-metric'>
                      <span className='problema__metric-label'>
                        {nls.planFrequencyLabel}
                      </span>
                      <strong className='problema__metric-value'>
                        {formatarValorSemPercentual(indicador?.frequencia_plan) || ''}
                      </strong>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default problema